import React from 'react';
import styled from 'styled-components';

import { TextField, Tooltip } from 'components';
import { FaRegQuestionCircle } from 'react-icons/fa';

const Container = styled.div`
    background-color: var(--primary-color);
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    margin: 0.5rem 0 0 0;
    border-style: solid;
    border-width: 2px;
    border-color: ${props => props.error ? 'var(--error-color)' : 'transparent'};
    display: flex;
    flex-direction: column;
    padding: 0.25rem 0.5rem;
`

const Label = styled.div`
    font-size: 0.8rem;
    font-weight: bold;
`

const Error = styled.div`
    font-size: 0.8rem;
    color: var(--error-color);
    margin-left: 0.2rem;
    :before {
        content: '*'
    }
`

const Row = styled.div`
    display: flex;
    align-items: center;
    margin: ${props => props.styles && props.styles.margin};
`

const TextInput = props => {
    const {
        label,
        value,
        onChange,
        onBlur,
        error,
        helper
    } = props;

    return(
        <Container error={error}>
            <Row styles={{margin: '0 0 0.2rem 0'}}>
                <Label>{label}</Label>
                {helper && 
                <Tooltip title={helper}>
                    <div style={{display: 'flex', color: 'var(--secondary-accent-color)', fontSize: '0.8rem', margin: '0 0.3rem', cursor: 'pointer'}}><FaRegQuestionCircle/></div>
                </Tooltip>}
                {error && <Error>{error}</Error>}
            </Row>
            <TextField value={value} type='single' addDelay={true} 
                onChange={(text) => onChange && onChange(text)} 
                onBlur={(text) => onBlur && onBlur(text)} />
        </Container>
    )
}

export default TextInput;